module.exports = __webpack_public_path__ + "static/media/logo.f540a811.svg";